export default function () {
    const elements = document.querySelectorAll('.event-grid--expandable');

    for (const element of elements) {
        const button = element.querySelector('.event-grid__view-more');

        if (!button) {
            continue;
        }

        button.addEventListener('click', () => {
            for (const item of element.querySelectorAll('.event-grid__item--hidden')) {
                item.classList.remove('event-grid__item--hidden');
            }

            button.closest('.event-grid__footer').remove();
        });
    }
}
